// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DT NOTES ||============================== //

export async function handleDTNotes(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/dt-notes', action.data);
    case 'read':
      return getRequest(`/dt-notes?dt-id=${action.id}`);
    case 'update':
      return putRequest(`/dt-notes/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/dt-notes/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDTNotes] - Unknown method');
      break;
  }
}
